import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setReportListPageSize as _setReportListPageSize } from '../../../Actions/ActionCreators/ReportPortalActionCreator';
import * as ReportPortalActions from '../../../Actions/ReportPortalActions';
import ReportView from '../../../Components/ReportPortal/ReportStatsTab/ReportView/ReportView';
import { getApiStatus } from '../../../Reducers/ApiStatusReducer';
import { getConfig } from '../../../Reducers/ConfigReducer';
import { getReportColumns as _getReportColumns, getReportListPageSize } from '../../../Reducers/ReportPortalReducer';
import { getFeatureToggleList } from '../../../Reducers/FeatureToggleReducer.ts';

const mapStateToProps = state => {
  return {
    userConfig: getConfig(state),
    pageSize: getReportListPageSize(state),
    fetchReportColumnsApiStatus: getApiStatus(state, 'fetchReportColumnsApiStatus'),
    saveReportQueryApiStatus: getApiStatus(state, 'saveReportQueryApiStatus'),
    reportColumns: _getReportColumns(state),
    featureToggleList: getFeatureToggleList(state),
  };
};

const mapDispatchToProps = {
  setReportListPageSize: _setReportListPageSize,
  clearExportReportApiStatus: ReportPortalActions.clearExportReportApiStatus,
  saveReportQuery: ReportPortalActions.saveReportQuery,
  clearSaveReportQueryApiStatus: ReportPortalActions.clearSaveReportQueryApiStatus,
  generateReport: ReportPortalActions.generateReport,
};

export function ReportViewContainer(props) {
  const {
    pageSize,
    setReportListPageSize,
    title,
    subtitle,
    filterConfig,
    reportStats,
    getReportStats,
    fetchReportStatsApiStatus,
    fetchReportColumnsApiStatus,
    exportReportApiStatus,
    clearExportReportApiStatus,
    reportColumns,
    savedReportDetails,
    onSaveQuerySuccess,
    saveReportQueryApiStatus,
    saveReportQuery,
    clearSaveReportQueryApiStatus,
    type,
    hidePagination,
    generateReport,
    featureToggleList,
  } = props;

  const [pageNumber, setReportListPageNumber] = useState(1);

  useEffect(() => {
    if (exportReportApiStatus?.status?.toUpperCase() === 'COMPLETED') {
      Modal.info({
        title: 'Your report is being generated.',
        content: 'This may take some time. You will receive a notification upon completion to download report.',
        okText: 'Close',
        okButtonProps: {
          shape: 'round',
        },
        onOk: clearExportReportApiStatus,
      });
    } else if (exportReportApiStatus?.error === 'CONFLICTING_REPORTGENERATIONREQUEST') {
      Modal.warning({
        title: 'Report generation is in progress',
        content:
          'Report generation with the same date range is in progress. You will receive a notification upon completion to download report.',
        okText: 'Close',
        okButtonProps: {
          shape: 'round',
        },
        onOk: clearExportReportApiStatus,
      });
    } else if (exportReportApiStatus?.status?.toUpperCase() === 'CANDIDATEREPORTWARNING') {
      Modal.warning({
        title: 'Report generation is in progress',
        content: exportReportApiStatus?.content,
        okText: 'Close',
        okButtonProps: {
          shape: 'round',
        },
        onOk: clearExportReportApiStatus,
      });
    }
  }, [exportReportApiStatus]);

  const reportColumnList = reportColumns?.[type];

  return (
    <div>
      <ReportView
        fetchReportStatsApiStatus={fetchReportStatsApiStatus}
        pageSize={pageSize}
        pageNumber={pageNumber}
        setReportListPageSize={setReportListPageSize}
        setReportListPageNumber={setReportListPageNumber}
        title={title}
        subtitle={subtitle}
        filterConfig={filterConfig}
        reportStats={reportStats}
        getReportStats={getReportStats}
        exportReportApiStatus={exportReportApiStatus}
        reportColumns={reportColumnList}
        fetchReportColumnsApiStatus={fetchReportColumnsApiStatus}
        savedReportDetails={savedReportDetails}
        onSaveQuerySuccess={onSaveQuerySuccess}
        saveReportQueryApiStatus={saveReportQueryApiStatus}
        onSaveQuery={saveReportQuery}
        clearSaveReportQueryApiStatus={clearSaveReportQueryApiStatus}
        type={type}
        hidePagination={hidePagination}
        generateReport={generateReport}
        featureToggleList={featureToggleList}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewContainer);
